import React, { Component } from "react";
import { connect } from "react-redux";
import LoadingOverlay from "../../components/LoadingOverlay";
import _ from "lodash";
import * as selector from "../../../common/selectors";
import { withStyles } from "@material-ui/core/styles";
import Constant from "../../../utils/Constant";
import Media from "react-media";
import WebView from "./components/WebView";
import MobileView from "./components/MobileView";
import { withRouter } from "react-router-dom";
import CustomToast from "../../components/CustomToast";
import Files from "react-butterfiles";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import Color from "../../../utils/Color";
import Toolbar from "@material-ui/core/Toolbar";
import AppBar from "@material-ui/core/AppBar";
import Image from "../../../assets";
import * as policyAction from "../../../common/actions/policy";
import * as policySelector from "../../../common/selectors/policy";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import { format, parse } from "date-fns";
import CustomModalV2 from "../../components/CustomModalV2";
import CustomModal from "../../components/CustomModal";
import CustomButton from "../../components/CustomButton";
import CustomModalV3 from "../../components/CustomModalV3";
import CustomTextInput from "../../components/CustomTextInput";
import ReactPhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import CustomText, {
  getFontSize,
  getFontWeight,
} from "../../components/CustomText";
import startsWith from "lodash.startswith";
import Grid from "@material-ui/core/Grid";
import AuthManager from "../../../utils/AuthManager";
import * as authSelector from "../../../common/selectors/auth";
import * as authAction from "../../../common/actions/auth";

const styles = (theme) => ({
  paper: {
    // marginTop: "0.4em",
    paddingLeft: "7rem",
    paddingRight: "7rem",
    marginTop: "2rem",
  },
  paperV2: {
    // marginTop: "0.4em",
    // paddingLeft: "7rem",
    // paddingRight: "7rem",
    paddingLeft: "0.6rem",
    paddingRight: "0.6rem",
    marginTop: "2rem",
  },
  attachIconStyle: {
    color: Color.secondaryTextColor,
    width: 20,
    height: 20,
    cursor: "pointer",
  },
  disabledAttachIconStyle: {
    color: Color.placeHolderTextColor,
    width: 20,
    height: 20,
  },

  labelTextInputTextStyle: {
    color: "#495057",
    fontWeight: "bold",
  },
  textInputContainer: {
    height: 35,
    //marginTop: 5,
    marginBottom: 10,
  },
  modalDesignV: {
    width: window.innerWidth * 0.96,
    marginBottom: 30,
    overFlow: "scroll",
    paddingLeft: 10,
    paddingRight: 10,
  },
  labelTextInputTextStyleV2: {
    color: Color.primaryTextColor,
    marginBottom: 0,
    ...getFontSize("medium"),
  },
  textInputContainerV2: {
    height: 40,
    marginBottom: 13,
    // marginTop: 5,
  },
  forgotTextStyleV2: {
    color: Color.primaryColor,
    ...getFontSize("small"),
    textAlign: "right",
    marginTop: 5,
  },
  etiqaLogoV2: {
    alignItems: "center",
    justifyContent: "center",
    margin: "auto",
    marginLeft: "auto",
    marginRight: "auto",
    display: "flex",
  },
});
const generalsQ = [
  { value: "I would like to check for my policy details", label: "1" },
  { value: "I would like to renew my insurance ", label: "2" },
  {
    value: "I want to check for my refund status/request for refund",
    label: "3",
  },
  {
    value: "I would like to check the outstanding premium amount.",
    label: "4",
  },
  {
    value:
      "I would like to request for the hardcopy of the annual policy and bonus statement.",
    label: "5",
  },
  { value: "I would like to cancel my policy.", label: "6" },
  {
    value: "I have made the payment, please help to check the payment status.",
    label: "7",
  },
  { value: "I would like the check my policy surrender value.", label: "8" },
  { value: "Can you arrange someone to give me a call?", label: "9" },
  {
    value: "What is the surrender value at the end of maturity of my policy",
    label: "10",
  },
  {
    value: "Want to check the next giro/credit card auto deduction date?",
    label: "11",
  },
  { value: "I want to check my claim's status", label: "12" },
  { value: "Need help to login/register to Etiqa account", label: "13" },
  { value: "I would like to update my contact and address", label: "14" },
];
const homeFireQ = [
  {
    value: "I would like to check if i have home/fire insurance with etiqa",
    label: "1",
  },
  {
    value: "I forgot my policy number, can check with my house address?",
    label: "2",
  },
  {
    value:
      "May i know will the fire insurance with etiqa be automatically cancelled if i don't renew it?",
    label: "3",
  },
  {
    value: "I would like to check the amount and status of my fire insurance",
    label: "4",
  },
  { value: "I want to check if my home insurance cover fire?", label: "5" },
  { value: "I still haven't receive my renewal letter.", label: "6" },
  {
    value:
      "What is covered in this policy? does it cover the mandatory fire insurance required by hdb?",
    label: "7",
  },
];
const maidQ = [
  {
    value:
      "I received the SMS notification about my sb transmission ref no. is not valid.",
    label: "1",
  },
  { value: "May i know where i get the sb transmission ref no?", label: "2" },
  { value: "What is covered under covid add-on?", label: "3" },
  { value: "What is security bond protector?", label: "4" },
  {
    value: "I had paid the insurance, when can i renew the work permit?",
    label: "5",
  },
  {
    value: "Does the plan cover the security bond by required by MOM?",
    label: "6",
  },
  { value: "I want to extend the policy duration", label: "7" },
  {
    value:
      "How should i decide the start date? Is it based on the work permit expiry date",
    label: "8",
  },
  {
    value:
      "What is the letter of guarantee to philippines overseas labour office(POLO)?",
    label: "9",
  },
  { value: "What is the refund policy?", label: "10" },
];
const savingQ = [
  { value: "What is the procedure for withdrawal?", label: "1" },
  {
    value: "Is there any withdrawal charge and daily withdrawal limit?",
    label: "2",
  },
  { value: "Is there a mininum amount for withdrawal?", label: "3" },
  {
    value:
      "If i do a full withdrawal, how long am i expect to receive the money?",
    label: "4",
  },
  { value: "What's the current crediting rate?", label: "5" },
  { value: "When is the last payment for my policy?", label: "6" },
  { value: "When can i receive the cash benefits?", label: "7" },
];
const motorQ = [
  {
    value: "I have made the renewal payment, when can i renew my road tax?",
    label: "1",
  },
  { value: "Please help to expedite my renewal", label: "2" },
  {
    value: "I would like to cancel my car insurance as i sold it already",
    label: "3",
  },
  { value: "I want to get a quote for my car insurance", label: "4" },
  {
    value: "I would like to extend my policy to align with the road tax date",
    label: "5",
  },
];
class LiveChat extends Component {
  constructor(props) {
    super(props);
    this.state = {
      createChatBtns: [],
      localUpdateMsgList: [],
      localThId: "",
      customToastStatus: false,
      toastMessage: "",
      userMsg: "",
      startInit: "",
      repeatCallingInterval: "",
      toGeneral: false,
      toHome: false,
      toMaid: false,
      toSaving: false,
      toMotor: false,
      showCat: true,
      localQueueT: "",
      localQueueNum: "",
      closeMessageStatus: false,
      showCatM: false,
      liveChatStartT: "",
      liveChatEndT: "",
      localEnableLiveChat: "",
      localEnableChatBot: "",
      selectedFiles: [],
      selected: "",
      diabledDate: [
        new Date("2022-08-16T00:00:00"),
        { from: new Date(0, 4, 18), to: new Date() - 1 },
      ],
      callBackView: false,
      localDDateLists: [{ from: new Date(0, 4, 18), to: new Date() - 1 }],
      selectTimeView: false,
      localDisableIntervTime: "",
      localDisableTimeEnd: "",
      localDisableTimeStart: "",
      disableDe: false,
      disableIn: false,
      callBackUserInfo: false,
      countryCode: "",
      mobileNo: "",
      localEmail: "",
      localName: "",
      callBackLoginPrompt: false,
      inCorrectLength: false,
      liveChatCallBackFlag: false,
      hideLiveChat: false,
      openCS: false,
      showT: 0,
      disT: "",
      userID: "",
      password: "",
      error: false,
      errorMessage: "",
      isVisibleAuthPrompt: false,
      localRespSource: "",
      localDisableTyping: false,
      blockTheChat: false,
      showT: 0,
      disTimeList: [],
    };
  }

  componentDidMount = () => {
    var monthG = new Date().getMonth() + 1;
    var yearN = new Date().getFullYear();
    var days = new Date(monthG, yearN, 0).getDate();
    var sundays = [8 - new Date(monthG + "/01/" + yearN).getDay()];
    var saturdays = [7 - new Date(monthG + "/01/" + yearN).getDay()];
    for (var i = sundays[0] + 7; i < days; i += 7) {
      sundays.push(i);
    }
    for (var i = saturdays[0] + 7; i < days; i += 7) {
      saturdays.push(i);
    }

    sundays.map((item) => {
      var c = String(monthG).padStart(2, "0");
      var d = String(item).padStart(2, "0");
      var a = yearN + "-" + c + "-" + d + "T00:00:00";
      var b = a.toString();
      this.state.localDDateLists.push(new Date(b));
    });

    saturdays.map((item) => {
      var c = String(monthG).padStart(2, "0");
      var d = String(item).padStart(2, "0");
      var a = yearN + "-" + c + "-" + d + "T00:00:00";
      var b = a.toString();
      this.state.localDDateLists.push(new Date(b));
    });

    const { getChatConfiguration, getCreateChat } = this.props;
    getChatConfiguration();
    if (sessionStorage.getItem("ThreadID")) {
      //getCreateChat("");
      this.props.getChatUpdate(
        sessionStorage.getItem("ThreadID"),
        sessionStorage.getItem("loginId")
      );
      this.setState({ localThId: sessionStorage.getItem("ThreadID") });
    } else {
      getCreateChat(null);
    }

    console.log("a");
  };

  componentWillUnmount() {
    window.sessionStorage.removeItem("MyToken");
    window.sessionStorage.removeItem("SessionID");
    window.sessionStorage.removeItem("loginId");
  }

  componentDidUpdate(prevProps, prevState) {
    const { getChatUpdate } = this.props;
    // console.log("see",this.state.selectedFiles)
    if (
      prevProps.getChatConfigurationData !== this.props.getChatConfigurationData
    ) {
      console.log(
        "getChatConfigurationData",
        this.props.getChatConfigurationData
      );
      const configData = policySelector.getChatConfigurationDataData(
        this.props.getChatConfigurationData
      );
      const liveChatPollingInterval = policySelector.getChatConfigurationDataLiveChatPollingInterval(
        configData
      );
      const liveChatEChatBot = policySelector.getChatConfigurationDataEnableChatbot(
        configData
      );
      const liveChatELiveC = policySelector.getChatConfigurationDataEnableLiveChat(
        configData
      );
      const liveChatEndT = policySelector.getChatConfigurationDataLiveChatWorkingEndTime(
        configData
      );
      const liveChatStartT = policySelector.getChatConfigurationDataLiveChatWorkingStartTime(
        configData
      );
      var numInterval = parseInt(liveChatPollingInterval) * 1000;
      if (liveChatELiveC === false && liveChatEChatBot === false) {
        this.setState({ closeMessageStatus: true });
      }
      this.setState({
        repeatCallingInterval: numInterval,
        liveChatStartT: liveChatStartT,
        liveChatEndT: liveChatEndT,
        localEnableLiveChat: liveChatELiveC,
        localEnableChatBot: liveChatEChatBot,
      });
    }

    if (prevProps.getCreateChatData !== this.props.getCreateChatData) {
      const createChatData = policySelector.getCreateChatDataData(
        this.props.getCreateChatData
      );
      const createChatStatus = policySelector.getCreateChatDataStatus(
        createChatData
      );
      const createChatBtns = policySelector.getCreateChatDataButtons(
        createChatData
      );
      const createChatThreadId = policySelector.getCreateChatDataThreadId(
        createChatData
      );
      console.log("createChatBtns", this.props.getCreateChatData);
      if (createChatStatus === true) {
        sessionStorage.setItem("ThreadID", createChatThreadId);
        console.log("createChatBtns", createChatBtns);
        this.setState({
          createChatBtns: createChatBtns,
          localThId: createChatThreadId,
        });
        getChatUpdate(createChatThreadId, sessionStorage.getItem("loginId"));
      } else {
        this.setState({
          startInit: false,
          closeMessageStatus: true,
          localThId: "",
        });
      }
    }

    if (prevProps.getChatUpdateData !== this.props.getChatUpdateData) {
      const updateChatData = policySelector.getChatUpdateDataData(
        this.props.getChatUpdateData
      );
      const updateMsgList = policySelector.getChatUpdateDataChatUpdateMessageLists(
        updateChatData
      );
      const updateMsgStatus = policySelector.getChatUpdateDataStatus(
        updateChatData
      );

      const chatQueueEstT = policySelector.getChatUpdateDataQueueEstTime(
        updateChatData
      );

      const chatQueueNum = policySelector.getChatUpdateDataQueueNumber(
        updateChatData
      );
      const createMsgBtn = policySelector.getCreateMessageDataButtons(
        updateChatData
      );
      // this.repeatingCallingUpdateChat();
      this.setState({
        localRespSource: updateChatData.ResponseSource,
        localDisableTyping: updateChatData.Disable_Typing,
      });
      if (
        updateChatData.ResponseSource === 3 &&
        updateChatData.Disable_Typing
      ) {
        this.setState({
          // customToastStatus: true,
          // toastMessage: "Please click one of the buttons",
          blockTheChat: true,
          userMsg: "Please select button above",
        });
      } else {
        this.setState({
          // customToastStatus: true,
          // toastMessage: "Please click one of the buttons",
          blockTheChat: false,
        });
        if (this.state.userMsg === "Please select button above") {
          this.setState({
            // customToastStatus: true,
            // toastMessage: "Please click one of the buttons",
            userMsg: "",
          });
        }
      }
      console.log(
        "updateChatData.ResponseSource",
        updateChatData.ResponseSource
      );
      const { localThId } = this.state;
      if (window.sessionStorage.getItem("loginId")) {
        setTimeout(function () {
          getChatUpdate(localThId, window.sessionStorage.getItem("loginId"));
        }, parseInt(this.state.repeatCallingInterval));
      } else {
        setTimeout(function () {
          getChatUpdate(localThId, sessionStorage.getItem("loginId"));
        }, parseInt(this.state.repeatCallingInterval));
      }
      // setTimeout(function () {
      //   if (window.localStorage.getItem("LoginId")) {
      //     getChatUpdate(localThId,window.localStorage.getItem("LoginId"));
      //   }else{
      //     getChatUpdate(localThId);
      //   }

      // }, parseInt(this.state.repeatCallingInterval));

      console.log("updateMsgListupdateMsgList", updateMsgList);

      if (updateMsgStatus === "Pending" || updateMsgStatus === "Connected") {
        this.setState({ startInit: false });
        const { getChatMessage } = this.props;
        if (createMsgBtn !== null) {
          console.log("c", createMsgBtn);
          this.setState({ createChatBtns: createMsgBtn });
        }

        getChatMessage(this.state.localThId, sessionStorage.getItem("loginId"));
        if (updateMsgStatus === "Connected") {
          this.setState({ hideLiveChat: true });
        }
      }

      if (updateMsgStatus === "Init") {
        this.setState({ startInit: true });
      }

      if (updateMsgStatus === "Queue" || updateMsgStatus === "Connecting") {
        this.setState({
          startInit: true,
          startQueueConnecting: true,
          localQueueT: chatQueueEstT,
          localQueueNum: chatQueueNum,
        });
      }

      if (updateMsgStatus === "Closed") {
        this.setState({
          startInit: false,
          closeMessageStatus: true,
          localThId: "",
        });
      }

      if (updateMsgStatus === "Cancelled") {
        this.setState({ startInit: false, localThId: "" });
        this.props.getCreateChat(null);
      }

      if (updateMsgStatus === "Callback") {
        this.setState({ startInit: false, liveChatCallBackFlag: true });
      }
    }

    if (prevProps.getChatMessageData !== this.props.getChatMessageData) {
      const chatMessageD = policySelector.getChatMessageDataData(
        this.props.getChatMessageData
      );
      const chatMessageLists = policySelector.getChatMessageDataGetChatMessageLists(
        chatMessageD
      );
      const chatMessageStatus = policySelector.getChatMessageDataStatus(
        chatMessageD
      );
      if (chatMessageStatus) {
        if (chatMessageLists.length !== this.state.localUpdateMsgList.length) {
          if (this.bottomRef) {
            this.bottomRef.scrollIntoView({ behavior: "smooth" });
          }

          this.setState({
            localUpdateMsgList: chatMessageLists,
            localScrollDown: true,
          });
        } else {
          this.setState({
            localUpdateMsgList: chatMessageLists,
            localScrollDown: false,
          });
        }
        //this.setState({ localUpdateMsgList: chatMessageLists });
      }
    }

    if (prevProps.getCreateMessageData !== this.props.getCreateMessageData) {
      const createMsgData = policySelector.getCreateMessageDataData(
        this.props.getCreateMessageData
      );
      const createMsgBtn = policySelector.getCreateMessageDataButtons(
        createMsgData
      );
      const createMsgStatus = policySelector.getCreateMessageDataStatus(
        createMsgData
      );
      const createMsgErrMsg = policySelector.getCreateMessageDataErrorMessage(
        createMsgData
      );

      if (createMsgStatus) {
        this.setState({ createChatBtns: createMsgBtn });
        getChatUpdate(this.state.localThId, sessionStorage.getItem("loginId"));
      } else {
        this.setState({
          customToastStatus: true,
          toastMessage:
            createMsgErrMsg || "Something went wrong please retry later.",
        });
      }
    }

    if (
      prevProps.getTwilioQuitQueueData !== this.props.getTwilioQuitQueueData
    ) {
      console.log(
        "this.props.getTwilioQuitQueueData",
        this.props.getTwilioQuitQueueData
      );
      const twilioQuitQueueData = policySelector.getTwilioQuitQueueDataData(
        this.props.getTwilioQuitQueueData
      );
      if (twilioQuitQueueData === true) {
        this.props.getChatUpdate(
          this.state.localThId,
          sessionStorage.getItem("loginId")
        );
      }
    }

    if (
      prevProps.getScheduleCallBackData !== this.props.getScheduleCallBackData
    ) {
      const scheduleCallBackD = policySelector.getScheduleCallBackDataData(
        this.props.getScheduleCallBackData
      );
      const scheduleCallBackStatus = policySelector.getScheduleCallBackDataStatus(
        scheduleCallBackD
      );
      const scheduleCallBackDisableLists = policySelector.getScheduleCallBackDataDisabledDateLists(
        scheduleCallBackD
      );
      if (scheduleCallBackStatus) {
        if (scheduleCallBackDisableLists.length > 0) {
          // this.setState({
          //   localDDateLists: [
          //     ...this.state.localDDateLists,
          //     ...scheduleCallBackDisableLists,
          //   ],
          // });
          scheduleCallBackDisableLists.map((item) => {
            var a = new Date(item);
            //console.log("aaaa",a)
            this.state.localDDateLists.push(a);
            //this.setState({ localDDateLists: [...this.state.localDDateLists, a] })
          });
        }
      }
    }

    if (
      prevProps.getDisabledTimeListsData !== this.props.getDisabledTimeListsData
    ) {
      const disabledTimeData = policySelector.getDisabledTimeListsDataData(
        this.props.getDisabledTimeListsData
      );
      const disabledTimeIntervalTime = policySelector.getDisabledTimeListsDataIntervalTime(
        disabledTimeData
      );
      const disabledTimeSCallBEnd = policySelector.getDisabledTimeListsDataScheduleCallbackEnd(
        disabledTimeData
      );
      const disabledTimeSCallBStart = policySelector.getDisabledTimeListsDataScheduleCallbackStart(
        disabledTimeData
      );
      const disabledTimeStatus = policySelector.getDisabledTimeListsDataStatus(
        disabledTimeData
      );
      var a = parseInt(disabledTimeIntervalTime) === 60 ? 100 : 30;
      if (disabledTimeStatus) {
        if (
          parseInt(disabledTimeSCallBStart) * 100 ===
          parseInt(disabledTimeSCallBEnd) * 100 - 100
        ) {
          this.setState({ disableDe: true, disableIn: true });
        } else {
          this.setState({ disableDe: true });
        }
        this.setState({
          selectTimeView: true,
          localDisableIntervTime: disabledTimeIntervalTime,
          localDisableTimeEnd: parseInt(disabledTimeSCallBStart) * 100 + a,
          localDisableTimeStart: parseInt(disabledTimeSCallBStart) * 100,
        });
      } else {
        this.setState({
          customToastStatus: true,
          toastMessage: "Something went wrong, Please retry later.",
        });
      }
    }

    if (prevProps.createAppointmentData !== this.props.createAppointmentData) {
      const createAppointmentData = policySelector.createAppointmentDataData(
        this.props.createAppointmentData
      );
      const createAppointmentStatus = policySelector.createAppointmentDataStatus(
        createAppointmentData
      );
      if (createAppointmentData) {
        // this.setState({
        //   customToastStatus: true,
        //   toastMessage: "Successfully schedule appointment.",
        // });
      } else {
        this.setState({
          customToastStatus: true,
          toastMessage: "Something went wrong, Please retry later.",
        });
      }
    }

    if (prevProps.loginData !== this.props.loginData) {
      //this.setState({ loginAction: false });
      const loginDataData = authSelector.getLoginDataData(this.props.loginData);
      const loginSuccess = authSelector.getLoginSuccess(this.props.loginData);

      const errorLoginData = authSelector.getMessage(loginDataData);
      const isMaybankAuthorization = authSelector.getLoginDataIsMaybankAutho(
        loginDataData
      );
      const token = authSelector.getLoginDataToken(loginDataData);
      //console.log("loginDataData",loginDataData)
      if (loginSuccess === false) {
        this.setState({
          //toastMessage: errorLoginData,
          error: true,
          errorMessage: errorLoginData,
        });
        this.setState({ loginAction: false });
      } else if (loginSuccess === true) {
        const loginDataData = authSelector.getLoginDataData(
          this.props.loginData
        );
        const sessionID = authSelector.getSessionID(loginDataData);

        const token = authSelector.getLoginDataToken(loginDataData);
        //AuthManager.setToken(token);
        window.sessionStorage.setItem("MyToken", token);
        window.sessionStorage.setItem("SessionID", sessionID);

        // this.props.getProfile();

        this.props.getInsiderClientInfoReq();
      }
    }
    if (
      prevProps.getInsiderClientInfoReqData !==
      this.props.getInsiderClientInfoReqData
    ) {
      // const loginId = policySelector.getLoginID(this.props.profile);
      const loginId = this.props.getInsiderClientInfoReqData?.login_id;
      window.sessionStorage.setItem("loginId", loginId);
      window.sessionStorage.removeItem("MyToken");
      getChatUpdate(this.state.localThId, loginId);
      this.setState({
        loginAction: false,
        isVisibleAuthPrompt: false,
        userID: "",
        password: "",
      });
    }

    if (
      prevProps.getChatReplyStatusData !== this.props.getChatReplyStatusData
    ) {
      if (this.props.getChatReplyStatusData) {
        // this.setState({
        //   customToastStatus: true,
        //   toastMessage: "Thank You For Your Feedback.",
        // });

        // Toast.success("Thank You For Your Feedback.")
        this.setState({
          customToastStatusV2: true,
          toastMessageV2: "Thank You For Your Feedback.",
        });
      }
    }

    if (prevProps.connectLiveChatData !== this.props.connectLiveChatData) {
      console.log("connectLiveChatData", this.props.connectLiveChatData);
      if (this.props.connectLiveChatData?.Data?.Status) {
        getChatUpdate(this.state.localThId, sessionStorage.getItem("loginId"));
      }
    }
  }

  repeatingCallingUpdateChat = () => {
    if (
      (this.state.localThId !== "" || this.state.localThId !== undefined) &&
      this.props.getChatUpdateLoading === false
    ) {
      let a = this.state.localThId;
      const { getChatUpdate } = this.props;
      setInterval(function () {
        //code goes here that will be run every 5 seconds.
        if (window.localStorage.getItem("LoginId")) {
          getChatUpdate(a, window.localStorage.getItem("LoginId"));
        } else {
          getChatUpdate(a);
        }
      }, 3000);
      console.log("th", this.state.localThId);
    }
  };

  handleAttachedFiles = () => {
    const { classes, messageHistoryList } = this.props;
    const { selectedFiles, closeMessageStatus } = this.state;
    //const status = enquirySelectors.getMessageHistoryStatus(messageHistoryList);
    return (
      <Files
        multiple={true}
        maxSize="10mb"
        multipleMaxSize="10mb"
        multipleMaxCount={3}
        accept={["application/pdf", "image/jpg", "image/jpeg", "image/png"]}
        onSuccess={(files) =>
          this.setState({ selectedFiles: selectedFiles.concat(files) })
        }
        onError={(errors) => {
          alert(errors[0].type);
        }}
        convertToBase64={true}
      >
        {({ browseFiles }) => (
          <>
            <AttachFileIcon
              onClick={!closeMessageStatus ? browseFiles : undefined}
              className={
                !closeMessageStatus
                  ? classes.attachIconStyle
                  : classes.disabledAttachIconStyle
              }
            />
          </>
        )}
      </Files>
    );
  };

  handleDeleteImage = (index) => {
    console.log("index", index, this.state.selectedFiles);
    const { selectedFiles, docName } = this.state;
    _.remove(selectedFiles, (item, key) => {
      console.log("key", key);
      return key === index;
    });

    this.setState({
      selectedFiles: selectedFiles.filter((index) => index === index),
    });
  };

  copyContent = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      this.setState({ customToastStatusV2: true, toastMessageV2: "Copied" });
    } catch (err) {
      console.error("Failed to Copy: ", err);
    }
  };

  onClickSendMessage = (
    localTitle,
    localPayload,
    localType,
    localIntent,
    localLevel
  ) => {
    const { getCreateMessage, getScheduleCallBack } = this.props;
    const { localThId } = this.state;
    //threadID,content,messageType,payload,attachedFiles
    this.setState({ blockTheChat: false, userMsg: "" });
    if (localPayload === "Schedule Callback") {
      this.setState({ callBackLoginPrompt: true });
      getScheduleCallBack(localThId);
    } else if (localType === "web_url") {
      window.open(localPayload);
    } else if (localType === "app_link") {
      if (localPayload === "mailto:customer.service@etiqa.com.sg") {
        window.open(localPayload);
      } else if (localPayload === "https://www.etiqa.com.sg/Whatsapp/") {
        window.open(localPayload);
      } else {
        this.setState({ openCS: true });
      }
    } else if (localType === "copy") {
      this.copyContent(localPayload);
    } else if (localPayload === "/auth_req") {
      this.setState({ isVisibleAuthPrompt: true });
    } else {
      getCreateMessage(
        localThId,
        localTitle,
        1,
        localPayload,
        "",
        localIntent !== null ? localIntent : "",
        localIntent !== null ? localLevel : "",
        sessionStorage.getItem("loginId")
          ? sessionStorage.getItem("loginId")
          : ""
      );
    }
  };

  handleCloseCustomToast = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({ customToastStatus: false });
  };

  handleCloseCustomToastV2 = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({ customToastStatusV2: false });
  };

  handleMessageChange = (e) => {
    this.setState({ userMsg: e.target.value });
  };

  onClickSendMessageNormal = () => {
    const { getCreateMessage } = this.props;
    const { localThId, userMsg, selectedFiles } = this.state;
    //threadID,content,messageType,payload,attachedFiles
    if (this.state.localRespSource === 3 && this.state.localDisableTyping) {
      this.setState({
        customToastStatus: true,
        toastMessage: "Please click one of the buttons",
        blockTheChat: true,
        userMsg: "Please select button above",
      });
      return;
    }
    if (selectedFiles.length > 0) {
      var type;
      var name;
      var data;
      selectedFiles.map((item, index) => {
        console.log("item", item.type);
        type = item.type;
        name = item.name;
        data = item.src.base64;
        // item.src.map((d,i)=>{
        //   data = d.base64;
        // })
      });
      var files = {
        FileName: name,
        FileData: data.split(",")[1],
        FilePath: "",
      };
    }

    if (selectedFiles !== []) {
      getCreateMessage(
        localThId,
        userMsg,
        type === "image/png" ? 3 : 2,
        "",
        files,
        "",
        "",
        sessionStorage.getItem("loginId")
          ? sessionStorage.getItem("loginId")
          : ""
      );
      this.setState({ selectedFiles: [] });
    } else {
      getCreateMessage(
        localThId,
        userMsg,
        1,
        "",
        "",
        "",
        "",
        "",
        sessionStorage.getItem("loginId")
          ? sessionStorage.getItem("loginId")
          : ""
      );
    }

    this.setState({ userMsg: "" });
  };

  onCloseLiveChat = () => {
    this.setState({ startInit: false });
    this.props.getTwilioQuitQueue(this.state.localThId);
    // this.props.getChatUpdate(this.state.localThId);
  };

  handleBottomRef = (ref) => {
    this.bottomRef = ref;
  };

  goToGeneral = () => {
    this.setState({ toGeneral: true, showCat: false, showCatM: false });
  };

  goToHome = () => {
    this.setState({ toHome: true, showCat: false, showCatM: false });
  };

  goToMaid = () => {
    this.setState({ toMaid: true, showCat: false, showCatM: false });
  };

  goToMotor = () => {
    this.setState({ toMotor: true, showCat: false, showCatM: false });
  };

  goToSaving = () => {
    this.setState({ toSaving: true, showCat: false, showCatM: false });
  };

  goBack = () => {
    this.setState({
      toGeneral: false,
      toHome: false,
      toMaid: false,
      toMotor: false,
      toSaving: false,
      showCat: true,
      showCatM: true,
    });
  };

  sendAskMsg = (msg) => {
    const { getCreateMessage, connectLiveChat } = this.props;
    const { localThId } = this.state;
    //threadID,content,messageType,payload,attachedFiles
    getCreateMessage(
      localThId,
      msg,
      1,
      "",
      "",
      "",
      "",
      sessionStorage.getItem("loginId") ? sessionStorage.getItem("loginId") : ""
    );
  };

  liveChatButtonClicked = () => {
    const { getCreateMessage, connectLiveChat } = this.props;
    const { localThId } = this.state;
    //threadID,content,messageType,payload,attachedFiles
    // getCreateMessage(
    //   localThId,
    //   "Chat with Customer Care",
    //   1,
    //   "/confirm_human_support",
    //   ""
    // );
    connectLiveChat(localThId);
  };

  onClickMenu = () => {
    const {
      toGeneral,
      toHome,
      toMaid,
      toMotor,
      toSaving,
      showCat,
    } = this.state;
    this.setState({
      toGeneral: false,
      toHome: false,
      toMaid: false,
      toMotor: false,
      toSaving: false,
      showCat: true,
    });
    if (
      toGeneral == true ||
      toHome == true ||
      toMaid == true ||
      toMotor == true ||
      toSaving == true
    ) {
      this.setState({ showCatM: false });
    } else {
      this.setState({ showCatM: !this.state.showCatM });
    }
  };

  handleKeypress = (event) => {
    //it triggers by pressing the enter key
    if (event.keyCode === 13) {
      this.onClickSendMessageNormal();
    }
  };

  disabledDateD = (current) => {
    //console.log("localDDateLists",this.state.localDDateLists)
    // var a = this.state.localDDateLists !== [] &&this.state.localDDateLists.map((item)=>{
    //   return(
    //     //console.log("item",item),
    //     new Date(current).getTime() === new Date(item).getTime()
    //   )
    // })
    // console.log("AAAAAA",a)
    return (
      current < Date.now() ||
      new Date(current).getDay() === 0 ||
      new Date(current).getDay() === 6 ||
      new Date(current).getTime() === new Date("2022-08-16T00:00:00").getTime()
    );
  };

  scheduleCallBackDatePicker = (date) => {
    const { selected, diabledDate, localDDateLists } = this.state;
    let footer = <p>Please pick a day.</p>;
    if (selected) {
      footer = <p>You picked {format(selected, "PP")}.</p>;
    }
    let confirmBtn = (
      <CustomButton
        disabled={selected ? false : true}
        style={{
          width: "70%",
          backgroundColor: selected ? "#00B4AF" : "#aaaaaa",
          color: selected ? "#fff" : "",
          border: "none",
          marginLeft: window.innerWidth < 700 ? 20 : 10,
          textTransform: "none",
        }}
        onClick={this.confirmDateBtnClick}
      >
        Confirm
      </CustomButton>
    );

    return (
      <div style={{ marginLeft: window.innerWidth < 700 ? "-9%" : "25%" }}>
        {/* {console.log("sssss", this.state.localDDateLists)} */}
        <DayPicker
          mode="single"
          selected={selected}
          onSelect={(selected) => this.setState({ selected: selected })}
          fromMonth={new Date()}
          toDate={new Date(Date.now() + 12096e5)}
          disabled={this.state.localDDateLists}
          //onSelect={setSelected}
          footer={footer}
        />
        {confirmBtn}
      </div>
    );
  };

  confirmDateBtnClick = () => {
    const { selected } = this.state;
    var a =
      new Date(selected).getFullYear() +
      "-" +
      String(new Date(selected).getMonth() + 1).padStart(2, "0") +
      "-" +
      String(new Date(selected).getDate()).padStart(2, "0") +
      "T00:00";

    this.props.getDisabledTimeLists(a);
    this.setState({ callBackView: false, selectTimeView: true });
  };

  confirmTimeBtnClick = (timeA, timeB) => {
    const { localThId, localName, localEmail, mobileNo, selected } = this.state;
    // threadID,
    // bookSTime,
    // bookETime,
    // customerN,
    // email,
    // mobile
    //this.props.createAppointmentData(this.state.selected);
    console.log(
      "localName",
      localName,
      localEmail,
      mobileNo,
      selected,
      timeA,
      timeB
    );
    var m = mobileNo.split("+");
    //2022-08-06T09:00:00.00
    //String(monthG).padStart(2, "0")
    //String(new Date(selected).getMonth()).padStart(2, "0")
    //String(new Date(selected).getDate()).padStart(2, "0")
    var a =
      new Date(selected).getFullYear() +
      "-" +
      String(new Date(selected).getMonth() + 1).padStart(2, "0") +
      "-" +
      String(new Date(selected).getDate()).padStart(2, "0") +
      "T" +
      timeA.replace(/\s/g, "") +
      ":00.00";
    var b =
      new Date(selected).getFullYear() +
      "-" +
      String(new Date(selected).getMonth() + 1).padStart(2, "0") +
      "-" +
      String(new Date(selected).getDate()).padStart(2, "0") +
      "T" +
      timeB.replace(/\s/g, "") +
      ":00.00";
    // var d = parseInt(timeA);
    // var e = parseInt(timeB);
    // var c = a.setHours(timeA);
    // var f = a.setHours(timeB);
    console.log("localTime", a, b);
    this.props.createAppointment(localThId, a, b, localName, localEmail, m[1]);
    this.setState({ selectTimeView: false });
  };

  onCloseSchedule = () => {
    this.setState({ callBackView: false });
  };

  proceedLogin = () => {
    window.open(process.env.REACT_APP_LOGIN_BASE_URL);
  };

  promptScheduleAsGuestOrLogin = () => {
    return (
      <div>
        <CustomButton
          style={{
            marginBottom: 10,
            width: window.innerWidth < 700 ? "70%" : "50%",
            marginLeft: window.innerWidth < 700 ? "20%" : "25%",
            textTransform: "none",
            backgroundColor: "#00B4AF",
            color: "#fff",
            border: "none",
            height: "40px",
          }}
          onClick={this.proceedLogin}
        >
          Login to proceed
        </CustomButton>
        <CustomButton
          style={{
            marginBottom: 10,
            width: window.innerWidth < 700 ? "70%" : "50%",
            marginLeft: window.innerWidth < 700 ? "20%" : "25%",
            textTransform: "none",
            backgroundColor: "#aaaaaa",
            color: "#fff",
            border: "none",
            height: "37.5px",
          }}
          onClick={this.proceedAsGuest}
        >
          Proceed as a guest
        </CustomButton>
      </div>
    );
  };

  proceedAsGuest = () => {
    this.setState({ callBackLoginPrompt: false, callBackUserInfo: true });
  };

  handleChangeMobile = (value, data, event, formattedValue) => {
    console.log("sadasdsdaddad", data, value);
    var countryCode = "+" + value.toString().slice(0, this.state.countryCode);
    var mobileNo = value.toString().slice(this.state.countryCode, 20);
    console.log("countryCode+mobileNo", countryCode + mobileNo);

    if (data.format.length - 3 !== (countryCode + mobileNo).length - 1) {
      this.setState({
        customToastStatus: true,
        toastMessage: "Mobile Number length is not correct",
        inCorrectLength: true,
      });
    } else {
      this.setState({
        customToastStatus: false,

        inCorrectLength: false,
      });
    }
    this.setState({ countryCode: data.countryCode.length });
    this.setState({ mobileNo: countryCode + mobileNo });
  };

  onChangeName = (e) => {
    this.setState({ localName: e.target.value });
  };

  onChangeEmail = (e) => {
    this.setState({ localEmail: e.target.value });
  };

  confirmUserBtnClick = () => {
    const { localName, localEmail, mobileNo, inCorrectLength } = this.state;
    if (inCorrectLength) {
      this.setState({
        customToastStatus: true,
        toastMessage: "Incorrect length of mobile number.",
      });
      return;
    }
    if (mobileNo === "") {
      this.setState({
        customToastStatus: true,
        toastMessage: "Mobile Number is required.",
      });
      return;
    }
    if (localName === "") {
      this.setState({
        customToastStatus: true,
        toastMessage: "Name is required.",
      });
      return;
    }
    if (localEmail === "") {
      this.setState({
        customToastStatus: true,
        toastMessage: "Email is required.",
      });
      return;
    }
    var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    if (!emailReg.test(localEmail)) {
      this.setState({
        customToastStatus: true,
        toastMessage: "Email is not valid.",
      });
      return;
    }

    this.setState({ callBackUserInfo: false, callBackView: true });
  };

  promptUserInfoUI = () => {
    const { classes } = this.props;
    const { localEmail, localName, mobileNo } = this.state;
    let confirmBtn = (
      <CustomButton
        disabled={false}
        style={{
          width: "70%",
          backgroundColor: "#00B4AF",
          color: "#fff",
          border: "none",
          marginLeft: "15%",
          textTransform: "none",
          marginTop: 20,
        }}
        onClick={this.confirmUserBtnClick}
      >
        Next
      </CustomButton>
    );
    return (
      <div>
        <div className={classes.inputContainer} style={{ marginBottom: 10 }}>
          <CustomText
            design={classes.mobileTitleTextStyle}
            style={{ marginBottom: 5 }}
          >
            Enter Your Mobile Number
          </CustomText>
          <ReactPhoneInput
            country={"sg"}
            value={this.state.mobileNo}
            onChange={this.handleChangeMobile}
            enableAreaCodeStretch
            countryCodeEditable={false}
            enableSearch={true}
            inputStyle={{
              width: "100%",
              height: "35px",
              fontSize: "13px",
              paddingLeft: "48px",
              borderRadius: "5px",
            }}
            inputProps={{
              required: true,
              autoFocus: true,
            }}

            //onKeyDown={this.handleKeypress}
            //onChange={(phoneNo) => this.setState({ phoneNo })}
          />
        </div>

        <div className={classes.inputContainer}>
          <CustomTextInput
            type={"text"}
            title={"Enter your name"}
            textstyle={classes.labelTextInputTextStyle}
            design={classes.textInputContainer}
            fullWidth={true}
            value={localName}
            onChange={this.onChangeName}
            //autoFocus={true}
            //onKeyUp={handleKeypress}
          />
        </div>

        <div className={classes.inputContainer}>
          <CustomTextInput
            type={"text"}
            title={"Enter your email"}
            textstyle={classes.labelTextInputTextStyle}
            design={classes.textInputContainer}
            fullWidth={true}
            value={localEmail}
            onChange={this.onChangeEmail}
            //autoFocus={true}
            //onKeyUp={handleKeypress}
          />
        </div>

        {confirmBtn}
      </div>
    );
  };

  onIncre = () => {
    const {
      localDisableTimeStart,
      localDisableTimeEnd,
      localDisableIntervTime,
    } = this.state;
    const disabledTimeData = policySelector.getDisabledTimeListsDataData(
      this.props.getDisabledTimeListsData
    );
    const disabledTimeIntervalTime = policySelector.getDisabledTimeListsDataIntervalTime(
      disabledTimeData
    );
    const disabledTimeSCallBEnd = policySelector.getDisabledTimeListsDataScheduleCallbackEnd(
      disabledTimeData
    );
    const disabledTimeSCallBStart = policySelector.getDisabledTimeListsDataScheduleCallbackStart(
      disabledTimeData
    );
    var a = parseInt(disabledTimeIntervalTime) === 60 ? 100 : 30;
    console.log(
      "ssssssssss",
      parseInt(localDisableTimeStart),
      parseInt(disabledTimeSCallBEnd)
    );
    if (
      parseInt(localDisableTimeStart) + 100 <
      parseInt(disabledTimeSCallBEnd) * 100
    ) {
      if (a === 100) {
        this.setState({
          localDisableTimeStart: parseInt(localDisableTimeStart) + a,
          localDisableTimeEnd: parseInt(localDisableTimeStart) + a + a,
        });
      }
      if (a === 30) {
        if (parseInt(localDisableTimeStart) % 100 === 0) {
          this.setState({
            localDisableTimeStart: parseInt(localDisableTimeStart) + a,
          });
        } else {
          this.setState({
            localDisableTimeStart: parseInt(localDisableTimeStart) + 70,
          });
        }
        if (parseInt(localDisableTimeEnd) % 100 === 0) {
          this.setState({
            localDisableTimeEnd: parseInt(localDisableTimeEnd) + a,
          });
        } else {
          this.setState({
            localDisableTimeEnd: parseInt(localDisableTimeEnd) + 70,
          });
        }
      }

      // this.setState({
      //   localDisableTimeStart: parseInt(localDisableTimeStart) + a,
      //   localDisableTimeEnd: parseInt(localDisableTimeStart) + a + a,
      // });
      this.setState({ disableDe: false });
    } else {
      this.setState({ disableIn: true });
    }
  };
  onDecre = () => {
    const {
      localDisableTimeStart,
      localDisableTimeEnd,
      localDisableIntervTime,
    } = this.state;
    const disabledTimeData = policySelector.getDisabledTimeListsDataData(
      this.props.getDisabledTimeListsData
    );
    const disabledTimeIntervalTime = policySelector.getDisabledTimeListsDataIntervalTime(
      disabledTimeData
    );
    const disabledTimeSCallBEnd = policySelector.getDisabledTimeListsDataScheduleCallbackEnd(
      disabledTimeData
    );
    const disabledTimeSCallBStart = policySelector.getDisabledTimeListsDataScheduleCallbackStart(
      disabledTimeData
    );
    var a = parseInt(disabledTimeIntervalTime) === 60 ? 100 : 30;
    console.log(
      "ssssssssss",
      parseInt(localDisableTimeStart),
      parseInt(disabledTimeSCallBEnd)
    );
    if (
      parseInt(localDisableTimeStart) >
      parseInt(disabledTimeSCallBStart) * 100
    ) {
      // this.setState({
      //   localDisableTimeStart: parseInt(localDisableTimeStart) - a,
      //   localDisableTimeEnd: parseInt(localDisableTimeEnd) - a,
      // });
      if (a === 100) {
        this.setState({
          localDisableTimeStart: parseInt(localDisableTimeStart) - a,
          localDisableTimeEnd: parseInt(localDisableTimeEnd) - a,
        });
      }
      if (a === 30) {
        if (parseInt(localDisableTimeStart) % 100 === 0) {
          this.setState({
            localDisableTimeStart: parseInt(localDisableTimeStart) - 70,
          });
        } else {
          this.setState({
            localDisableTimeStart: parseInt(localDisableTimeStart) - 30,
          });
        }
        if (parseInt(localDisableTimeEnd) % 100 === 0) {
          this.setState({
            localDisableTimeEnd: parseInt(localDisableTimeEnd) - 70,
          });
        } else {
          this.setState({
            localDisableTimeEnd: parseInt(localDisableTimeEnd) - 30,
          });
        }
      }

      this.setState({ disableIn: false });
    } else {
      this.setState({ disableDe: true });
    }
  };

  promptChooseTime = () => {
    const disabledTimeData = policySelector.getDisabledTimeListsDataData(
      this.props.getDisabledTimeListsData
    );
    const disabledTimeIntervalTime = policySelector.getDisabledTimeListsDataIntervalTime(
      disabledTimeData
    );
    const disabledTimeSCallBEnd = policySelector.getDisabledTimeListsDataScheduleCallbackEnd(
      disabledTimeData
    );
    const disabledTimeSCallBStart = policySelector.getDisabledTimeListsDataScheduleCallbackStart(
      disabledTimeData
    );
    const { disableDe, disableIn } = this.state;
    var disDe =
      this.state.localDisableTimeStart ===
      parseInt(disabledTimeSCallBStart) * 100
        ? true
        : false;
    var disIn =
      this.state.localDisableTimeStart ===
      parseInt(disabledTimeSCallBEnd) * 100 - 100
        ? true
        : false;

    var imA =
      this.state.localDisableTimeStart < 1000
        ? "0" +
          this.state.localDisableTimeStart.toString().slice(0, -2) +
          ":" +
          this.state.localDisableTimeStart.toString().slice(-2)
        : this.state.localDisableTimeStart.toString().slice(0, -2) +
          ":" +
          this.state.localDisableTimeStart.toString().slice(-2);

    var imB =
      this.state.localDisableTimeEnd < 1000
        ? "0" +
          this.state.localDisableTimeEnd.toString().slice(0, -2) +
          ":" +
          this.state.localDisableTimeEnd.toString().slice(-2)
        : this.state.localDisableTimeEnd.toString().slice(0, -2) +
          ":" +
          this.state.localDisableTimeEnd.toString().slice(-2);

    let confirmBtn = (
      <CustomButton
        disabled={false}
        style={{
          width: "70%",
          backgroundColor: "#00B4AF",
          color: "#fff",
          border: "none",
          marginLeft: 10,
          textTransform: "none",
        }}
        onClick={() => this.confirmTimeBtnClick(imA, imB)}
      >
        Confirm
      </CustomButton>
    );
    return (
      <div style={{ marginLeft: "23%", marginBottom: 10 }}>
        <div>
          Between{" "}
          <span
            style={{
              fontWeight: "bold",
              fontSize: "1.8rem",
              marginLeft: 10,
              marginRight: 10,
            }}
          >
            {this.state.localDisableTimeStart < 1000
              ? "0" +
                this.state.localDisableTimeStart.toString().slice(0, -2) +
                ":" +
                this.state.localDisableTimeStart.toString().slice(-2)
              : this.state.localDisableTimeStart.toString().slice(0, -2) +
                ":" +
                this.state.localDisableTimeStart.toString().slice(-2)}
          </span>{" "}
          -{" "}
          <span
            style={{
              fontWeight: "bold",
              fontSize: "1.8rem",
              marginLeft: 10,
              marginRight: 10,
            }}
          >
            {this.state.localDisableTimeEnd < 1000
              ? "0" +
                this.state.localDisableTimeEnd.toString().slice(0, -2) +
                ":" +
                this.state.localDisableTimeEnd.toString().slice(-2)
              : this.state.localDisableTimeEnd.toString().slice(0, -2) +
                ":" +
                this.state.localDisableTimeEnd.toString().slice(-2)}
          </span>{" "}
          {this.state.localDisableTimeEnd / 100 > 11 ? "PM" : "AM"}
        </div>
        <div
          style={{
            marginLeft: window.innerWidth < 700 ? "7%" : "28%",
            marginTop: 10,
            marginBottom: 20,
          }}
        >
          <button
            disabled={disableIn || disIn}
            style={{
              fontWeight: "bold",
              fontSize: "2rem",
              marginLeft: 10,
              marginRight: 20,
              background: "none",
              border: "none",
              //width: "20px",
              cursor: disableIn || disIn ? "" : "pointer",
              color: disableIn || disIn ? "#aaaaaa" : "",
            }}
            onClick={this.onIncre}
          >
            +
          </button>{" "}
          <button
            disabled={disableDe || disDe}
            style={{
              background: "none",
              fontWeight: "bold",
              fontSize: "2rem",
              border: "none",
              marginLeft: 10,
              cursor: disableDe || disDe ? "" : "pointer",
              color: disableDe || disDe ? "#aaaaaa" : "",
            }}
            onClick={this.onDecre}
          >
            -
          </button>
        </div>
        {confirmBtn}
      </div>
    );
  };

  promptChooseTimeV2 = () => {
    const disabledTimeData = policySelector.getDisabledTimeListsDataData(
      this.props.getDisabledTimeListsData
    );
    const disabledTimeIntervalTime = policySelector.getDisabledTimeListsDataIntervalTime(
      disabledTimeData
    );
    const disabledTimeSCallBEnd = policySelector.getDisabledTimeListsDataScheduleCallbackEnd(
      disabledTimeData
    );
    const disabledTimeSCallBStart = policySelector.getDisabledTimeListsDataScheduleCallbackStart(
      disabledTimeData
    );
    const disableTimeList = policySelector.getDisabledTimeListsDisableTimeLists(
      disabledTimeData
    );
    var disTimeList = [];
    if (disableTimeList !== null) {
      disableTimeList.length > 0 &&
        disableTimeList.map((item, index) => {
          var a = item.split("T")[1];
          var b = a.substring(0, a.length - 3);
          console.log("BBBB!!!BBBB", b);
          if (disabledTimeIntervalTime === 60) {
            console.log("AAA!!!AAA", b);
            if (b === "09:00") {
              b = "09:00 - 10:00";
              disTimeList.push(b);
            } else if (b === "10:00") {
              b = "10:00 - 11:00";
              disTimeList.push(b);
            } else if (b === "11:00") {
              b = "11:00 - 12:00";
              disTimeList.push(b);
            } else if (b === "12:00") {
              b = "12:00 - 13:00";
              disTimeList.push(b);
            } else if (b === "13:00") {
              b = "13:00 - 14:00";
              disTimeList.push(b);
            } else if (b === "14:00") {
              b = "14:00 - 15:00";
              disTimeList.push(b);
            } else if (b === "15:00") {
              b = "15:00 - 16:00";
              disTimeList.push(b);
            } else if (b === "16:00") {
              b = "16:00 - 17:00";
              disTimeList.push(b);
            } else if (b === "17:00") {
              b = "17:00 - 18:00";
              disTimeList.push(b);
            }
          } else {
            if (b === "09:00") {
              b = "09:00 - 09:30";
            } else if (b === "09:30") {
              b = "09:30 - 10:00";
            } else if (b === "10:00") {
              b = "10:00 - 10:30";
            } else if (b === "10:30") {
              b = "10:30 - 11:00";
            } else if (b === "11:00") {
              b = "11:00 - 11:30";
            } else if (b === "11:30") {
              b = "11:30 - 12:00";
            } else if (b === "12:00") {
              b = "12:00 - 12:30";
            } else if (b === "12:30") {
              b = "12:30 - 13:00";
            } else if (b === "13:00") {
              b = "13:00 - 13:30";
            } else if (b === "13:30") {
              b = "13:30 - 14:00";
            } else if (b === "14:00") {
              b = "14:00 - 14:30";
            } else if (b === "14:30") {
              b = "14:30 - 15:00";
            } else if (b === "15:00") {
              b = "15:00 - 15:30";
            } else if (b === "15:30") {
              b = "15:30 - 16:00";
            } else if (b === "16:00") {
              b = "16:00 - 16:30";
            } else if (b === "16:30") {
              b = "16:30 - 17:00";
            } else if (b === "17:00") {
              b = "17:00 - 17:30";
            }
            disTimeList.push(b);
          }

          //console.log("itemitemitemitemitem", item.split("T")[1]);
        });
    }

    console.log("disableTimeList", disTimeList);
    var hourA = [
      "09:00 - 10:00",
      "10:00 - 11:00",
      "11:00 - 12:00",
      "12:00 - 13:00",
      "13:00 - 14:00",
      "14:00 - 15:00",
      "15:00 - 16:00",
      "16:00 - 17:00",
    ];
    var minB = [
      "09:00 - 09:30",
      "09:30 - 10:00",
      "10:00 - 10:30",
      "10:30 - 11:00",
      "11:00 - 11:30",
      "11:30 - 12:00",
      "12:00 - 12:30",
      "12:30 - 13:00",
      "13:00 - 13:30",
      "13:30 - 14:00",
      "14:00 - 14:30",
      "14:30 - 15:00",
      "15:00 - 15:30",
      "15:30 - 16:00",
      "16:00 - 16:30",
      "16:30 - 17:00",
    ];
    var finalTimeL;
    if (disabledTimeIntervalTime === 60) {
      //finalTimeL = hourA;
      finalTimeL = hourA.filter((val) => !disTimeList.includes(val));

      console.log("finalTimeL", finalTimeL);
    } else {
      finalTimeL = minB.filter((val) => !disTimeList.includes(val));
    }
    const { disableDe, disableIn } = this.state;
    var disDe =
      this.state.localDisableTimeStart ===
      parseInt(disabledTimeSCallBStart) * 100
        ? true
        : false;
    var disIn =
      this.state.localDisableTimeStart ===
      parseInt(disabledTimeSCallBEnd) * 100 - 100
        ? true
        : false;

    var imA = finalTimeL[this.state.showT].split("-")[0];

    var imB = finalTimeL[this.state.showT].split("-")[1];

    let confirmBtn = (
      <CustomButton
        disabled={false}
        style={{
          width: "70%",
          backgroundColor: "#00B4AF",
          color: "#fff",
          border: "none",
          marginLeft: 10,
          textTransform: "none",
        }}
        onClick={() => this.confirmTimeBtnClick(imA, imB)}
      >
        Confirm
      </CustomButton>
    );
    //var showT = 0;
    const { showT } = this.state;
    let onI = () => {
      console.log("ASDASDDSDd", finalTimeL.length);
      if (showT + 1 >= finalTimeL.length) {
        return;
      } else {
        console.log("ASDASDDSDd", showT);
        return this.setState({ showT: showT + 1 });
      }
    };

    let deI = () => {
      console.log("ASDASDDSDd");
      if (showT > 0) {
        return this.setState({ showT: showT - 1 });
      } else {
        return this.setState({ showT: 0 });
      }
    };

    return (
      <div style={{ marginLeft: "23%", marginBottom: 10 }}>
        <div>
          Between{" "}
          <span
            style={{
              fontWeight: "bold",
              fontSize: "1.8rem",
              marginLeft: 10,
              marginRight: 10,
            }}
          >
            {finalTimeL[showT]}
          </span>{" "}
          {/* {this.state.localDisableTimeEnd / 100 > 11 ? "PM" : "AM"} */}
        </div>
        <div
          style={{
            marginLeft: window.innerWidth < 700 ? "7%" : "28%",
            marginTop: 10,
            marginBottom: 20,
          }}
        >
          <button
            //disabled={disableIn || disIn}
            style={{
              fontWeight: "bold",
              fontSize: "2rem",
              marginLeft: 10,
              marginRight: 20,
              background: "none",
              border: "none",
              //width: "20px",
              cursor: "pointer",
              color: "",
            }}
            onClick={onI}
          >
            +
          </button>{" "}
          <button
            //disabled={disableDe || disDe}
            style={{
              background: "none",
              fontWeight: "bold",
              fontSize: "2rem",
              border: "none",
              marginLeft: 10,
              cursor: "pointer",
              color: "",
            }}
            onClick={deI}
          >
            -
          </button>
        </div>
        {confirmBtn}
      </div>
    );
  };

  onCloseUserInfo = () => {
    this.setState({ callBackUserInfo: false });
  };

  onClosePreferTime = () => {
    this.setState({ selectTimeView: false });
  };

  onCloseLoginPrompt = () => {
    this.setState({ callBackLoginPrompt: false });
  };

  // promptCustomerCareHotLine = () => {
  //   return (
  //     <div
  //       style={{
  //         display: "flex",
  //         flexDirection: "column",
  //         justifyContent: "center",
  //         textAlign: "center",
  //         marginBottom: 20,
  //       }}
  //     >
  //       <div>Customer Care Hot Line</div>
  //       <div>
  //         tel: <span style={{ fontWeight: "bold" }}>+6568878777</span>
  //       </div>
  //     </div>
  //   );
  // };

  promptCustomerCareHotLine = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          textAlign: "center",
          marginBottom: 30,
        }}
      >
        <div style={{ fontWeight: "bold", fontSize: "16px" }}>
          Customer Care Hotline
        </div>
        <div>
          <span style={{ fontWeight: "bold", fontSize: "16px" }}>
            +65 6887 8777
          </span>
        </div>
        <div style={{ marginLeft: "2%", marginTop: 10, fontSize: "13px" }}>
          Operating hours: Monday to Friday, 8:45am to 5.30pm (excluding Public
          Holidays)
        </div>
      </div>
    );
  };

  onCloseHotline = () => {
    this.setState({ openCS: false });
  };

  modalContainer = () => {
    const {
      updateClientInfoLoading,
      checkUserIDLoading,
      couponConvertLoading,
    } = this.props;
    const {
      email,
      password,
      confirmPassword,
      newUserID,
      dob,
      name,
      showPassword,
      showConfirmPassword,
      toastSuccess,
    } = this.state;
    const { classes } = this.props;
    return (
      <div style={{ paddingRight: 15, marginBottom: 5 }}>
        <Grid container>
          <Grid item xs={3}></Grid>
          <Grid item xs={6} className={classes.etiqaLogoV2}>
            <img src={Image.etiqaLogoCouponCode} style={{ width: "100px" }} />
          </Grid>
          <Grid item xs={3}></Grid>
        </Grid>

        <div>
          <CustomTextInput
            title={"User ID"}
            textstyle={classes.labelTextInputTextStyleV2}
            design={classes.textInputContainerV2}
            fullWidth={true}
            value={this.state.userID}
            onChange={this.onChangeUserID}
            error={this.state.error}
          />
          <CustomText design={classes.forgotTextStyleV2}>
            <span
              onClick={this.onClickForgotUserID}
              style={{ cursor: "pointer" }}
            >
              Forgot User ID?
            </span>
          </CustomText>
        </div>
        <div>
          <CustomTextInput
            id="outlined-adornment-password"
            type={"password"}
            title={"Password"}
            textstyle={classes.labelTextInputTextStyleV2}
            design={classes.textInputContainerV2}
            fullWidth={true}
            value={this.state.password}
            onChange={this.onChangePassword}
            //onKeyUp={handleKeypress}
            error={this.state.error}
            errorMessage={this.state.errorMessage}
          />
          <CustomText design={classes.forgotTextStyleV2}>
            <span
              onClick={this.onClickForgotPassword}
              style={{ cursor: "pointer" }}
            >
              Forgot Password?
            </span>
          </CustomText>
        </div>

        {couponConvertLoading || this.props.getChatReplyStatusLoading ? (
          <LoadingOverlay loading={true} />
        ) : (
          false
        )}
        {checkUserIDLoading ? <LoadingOverlay loading={true} /> : false}
        {this.state.loginAction ? <LoadingOverlay loading={true} /> : false}
      </div>
    );
  };

  onChangeUserID = (event) => {
    this.setState({ userID: event.target.value });
  };

  onChangePassword = (event) => {
    this.setState({ password: event.target.value });
  };

  onClickForgotPassword = () => {
    window.open(process.env.REACT_APP_LOGIN_BASE_URL + "#/ForgotPassword");
  };

  onClickForgotUserID = () => {
    window.open(process.env.REACT_APP_LOGIN_BASE_URL + "#/ForgotUserID");
  };

  onClickUpdate = () => {
    const {
      open,
      password,
      confirmPassword,
      userID,
      availableUserID,
    } = this.state;
    const { covertCouponToEtiqaDollar, couponDetailsData } = this.props;
    // const detailData = referAndEarnSelectors.couponDetailsDataData(
    //   couponDetailsData
    // );
    // const couponAmount = referAndEarnSelectors.couponDetailsDataCouponAmount(
    //   detailData
    // );
    // const couponCode = referAndEarnSelectors.couponDetailsDataCouponCode(
    //   detailData
    // );
    // const couponExpireText = referAndEarnSelectors.couponDetailsDataCouponExpiredText(
    //   detailData
    // );
    if (userID === "") {
      this.setState({
        error: true,
        errorMessage: "UserId/Passport/Fin No. cant be empty",
      });
      return;
    }

    if (password === "") {
      this.setState({
        error: true,
        errorMessage: "Password cant be empty",
      });
      return;
    }

    this.onClickLogin();
    // covertCouponToEtiqaDollar(newUserID, password, couponCode);

    // this.setState({ open: !open });
    // this.setState({ updateAction: true });
  };

   onClickLogin = async () => {
    const {
      userID,
      password,
      localAuthClientID,
      localAuthRedirectURL,
      localAuthState,
    } = this.state;
    const { postLoginRequest } = this.props;
    if (userID && password !== "") {
      // postLoginRequest(userID, password, "", "", "");
      // this.setState({ loginAction: true });

      // window.dataLayer = window.dataLayer || [];
      // console.log("dataLayer",window.dataLayer)
      // window.dataLayer.push({
      //   event: "login",
      //   user_id: userID,
      // });
      try {
        // Call reCAPTCHA API to get the token
        const recaptchaToken = await window.grecaptcha.execute(
          "6Lce7OMZAAAAALxOm9WwIETw1EL9UB73SDe4g0Tx",
          { action: "WEB_LOGIN" }
        );
  
        if (!recaptchaToken) {
          this.setState({
            //toastMessage: "User ID and Password can not be empty.",
            error: true,
            errorMessage: "Unable to verify reCAPTCHA. Please try again.",
          });
          return;
        }
  
        postLoginRequest(userID, password, "", "", "",recaptchaToken);
        this.setState({ loginAction: true });

      } catch (error) {
        this.setState({
          //toastMessage: "User ID and Password can not be empty.",
          error: true,
          errorMessage: "Error during reCAPTCHA verification. Please try again.",
        });
      }

    } else {
      //this.setState({ customToastStatus: true });
      this.setState({
        //toastMessage: "User ID and Password can not be empty.",
        error: true,
        errorMessage: "User ID and Password can not be empty.",
      });
    }
  };

  handleCloseCreditToeWallet = () => {
    this.setState({ isVisibleAuthPrompt: false });
  };

  sendLikeButton = (chatId, likeDisBtn) => {
    console.log("WTF!");
    let button = likeDisBtn === 1 ? true : false;
    this.props.getChatReplyStatus(chatId, button);
  };

  render() {
    const {
      classes,
      getChatConfigurationLoading,
      getCreateChatLoading,
      getChatUpdateLoading,
      getCreateMessageLoading,
      getTwilioQuitQueueLoading,
      getScheduleCallBackLoading,
      getDisabledTimeListsLoading,
      createAppointmentLoading,
      getChatReplyStatusLoading,
    } = this.props;
    const {
      createChatBtns,
      localUpdateMsgList,
      userMsg,
      startInit,
      toGeneral,
      toHome,
      toMaid,
      toSaving,
      toMotor,
      showCat,
      localQueueNum,
      localQueueT,
      closeMessageStatus,
      showCatM,
      localEnableLiveChat,
      selectedFiles,
      callBackView,
      selectTimeView,
      callBackUserInfo,
      localEmail,
      localName,
      callBackLoginPrompt,
      liveChatCallBackFlag,
      hideLiveChat,
      blockTheChat,
    } = this.state;
    return (
      <div>
        {" "}
        {window.innerWidth > 600 ? (
          <AppBar
            position="sticky"
            className={classes.appBar}
            style={{
              background:
                "transparent linear-gradient(273deg, #67BB97 0%, #0B4F83 100%) 0% 0% no-repeat padding-box",
            }}
          >
            <Toolbar
              className={classes.toolbarStyle}
              style={{
                justifyContent: "space-between",
                //alignItems: "center",
                display: "flex-start",
                flexDirection: "row",
                marginLeft: "5em",
              }}
            >
              <img
                src={Image.tiqconnectLogo}
                style={{ width: 112, height: 37 }}
              />
            </Toolbar>
          </AppBar>
        ) : (
          false
        )}
        <div
          className={window.innerWidth < 700 ? classes.paperV2 : classes.paper}
        >
          <Media queries={Constant.GLOBAL_MEDIA_QUERIES}>
            {(matches) =>
              matches.small ? (
                <MobileView
                  handleAttachedFiles={this.handleAttachedFiles}
                  createChatBtns={createChatBtns}
                  localUpdateMsgList={localUpdateMsgList}
                  onClickSendMessage={this.onClickSendMessage}
                  handleMessageChange={this.handleMessageChange}
                  onClickSendMessageNormal={this.onClickSendMessageNormal}
                  userMsg={userMsg}
                  startInit={startInit}
                  onCloseLiveChat={this.onCloseLiveChat}
                  generalsQ={generalsQ}
                  handleBottomRef={this.handleBottomRef}
                  homeFireQ={homeFireQ}
                  maidQ={maidQ}
                  savingQ={savingQ}
                  motorQ={motorQ}
                  goBack={this.goBack}
                  showCat={showCat}
                  toGeneral={toGeneral}
                  toHome={toHome}
                  toMaid={toMaid}
                  toSaving={toSaving}
                  toMotor={toMotor}
                  goToGeneral={this.goToGeneral}
                  goToHome={this.goToHome}
                  goToMaid={this.goToMaid}
                  goToMotor={this.goToMotor}
                  goToSaving={this.goToSaving}
                  sendAskMsg={this.sendAskMsg}
                  liveChatButtonClicked={this.liveChatButtonClicked}
                  localQueueNum={localQueueNum}
                  localQueueT={localQueueT}
                  closeMessageStatus={closeMessageStatus}
                  onClickMenu={this.onClickMenu}
                  showCatM={showCatM}
                  localEnableLiveChat={localEnableLiveChat}
                  selectedFiles={selectedFiles}
                  handleDeleteImage={this.handleDeleteImage}
                  liveChatCallBackFlag={liveChatCallBackFlag}
                  hideLiveChat={hideLiveChat}
                  sendLikeButton={this.sendLikeButton}
                  blockTheChat={blockTheChat}
                />
              ) : (
                <WebView
                  handleAttachedFiles={this.handleAttachedFiles}
                  createChatBtns={createChatBtns}
                  localUpdateMsgList={localUpdateMsgList}
                  onClickSendMessage={this.onClickSendMessage}
                  handleMessageChange={this.handleMessageChange}
                  onClickSendMessageNormal={this.onClickSendMessageNormal}
                  userMsg={userMsg}
                  startInit={startInit}
                  onCloseLiveChat={this.onCloseLiveChat}
                  generalsQ={generalsQ}
                  handleBottomRef={this.handleBottomRef}
                  homeFireQ={homeFireQ}
                  maidQ={maidQ}
                  savingQ={savingQ}
                  motorQ={motorQ}
                  goBack={this.goBack}
                  showCat={showCat}
                  toGeneral={toGeneral}
                  toHome={toHome}
                  toMaid={toMaid}
                  toSaving={toSaving}
                  toMotor={toMotor}
                  goToGeneral={this.goToGeneral}
                  goToHome={this.goToHome}
                  goToMaid={this.goToMaid}
                  goToMotor={this.goToMotor}
                  goToSaving={this.goToSaving}
                  sendAskMsg={this.sendAskMsg}
                  liveChatButtonClicked={this.liveChatButtonClicked}
                  localQueueNum={localQueueNum}
                  localQueueT={localQueueT}
                  closeMessageStatus={closeMessageStatus}
                  localEnableLiveChat={localEnableLiveChat}
                  selectedFiles={selectedFiles}
                  handleDeleteImage={this.handleDeleteImage}
                  handleKeypress={this.handleKeypress}
                  liveChatCallBackFlag={liveChatCallBackFlag}
                  hideLiveChat={hideLiveChat}
                  sendLikeButton={this.sendLikeButton}
                  localScrollDown={this.state.localScrollDown}
                  blockTheChat={blockTheChat}
                />
              )
            }
          </Media>

          {getChatConfigurationLoading ||
          getCreateChatLoading ||
          // getChatUpdateLoading ||
          getCreateMessageLoading ||
          getTwilioQuitQueueLoading ||
          getScheduleCallBackLoading ||
          getDisabledTimeListsLoading ||
          createAppointmentLoading ||
          getChatReplyStatusLoading ? (
            <LoadingOverlay loading={true} />
          ) : (
            false
          )}
          <CustomToast
            open={this.state.customToastStatus}
            handleCloseCustomToast={this.handleCloseCustomToast}
            title={this.state.toastMessage}
            warning
          />
          <CustomToast
            open={this.state.customToastStatusV2}
            handleCloseCustomToast={this.handleCloseCustomToastV2}
            title={this.state.toastMessageV2}
            success
          />
          <CustomModal
            open={callBackView}
            handleClose={this.onCloseSchedule}
            loading={
              getScheduleCallBackLoading ||
              getDisabledTimeListsLoading ||
              createAppointmentLoading
            }
            modalTitle={"Schedule Callback"}
            isTitleCenter
            titlestyle={classes.modalTitleStyle}
            modalDesign={window.innerWidth < 700 ? classes.modalDesignV : ""}
            //submitButtonText={"Confirm"}
            modalComponent={this.scheduleCallBackDatePicker()}
            disableBackdropClick
            //handleSubmitButton={this.onClickConfirmReview}
            isWhiteCloseIcon={false}
            buttonStyle={{ justifyContent: "center" }}
          />

          <CustomModalV2
            open={callBackLoginPrompt}
            handleClose={this.onCloseLoginPrompt}
            loading={
              getScheduleCallBackLoading ||
              getDisabledTimeListsLoading ||
              createAppointmentLoading
            }
            modalTitle={"Schedule Callback"}
            isTitleCenter
            titlestyle={classes.modalTitleStyle}
            modalDesign={""}
            //submitButtonText={"Confirm"}
            modalComponent={this.promptScheduleAsGuestOrLogin()}
            disableBackdropClick
            //handleSubmitButton={this.onClickConfirmReview}
            isWhiteCloseIcon={false}
            buttonStyle={{ justifyContent: "center" }}
          />

          <CustomModalV2
            open={callBackUserInfo}
            handleClose={this.onCloseUserInfo}
            loading={
              getScheduleCallBackLoading ||
              getDisabledTimeListsLoading ||
              createAppointmentLoading
            }
            modalTitle={"Schedule Callback"}
            isTitleCenter
            titlestyle={classes.modalTitleStyle}
            modalDesign={classes.modalDesign}
            //submitButtonText={"Confirm"}
            modalComponent={this.promptUserInfoUI()}
            disableBackdropClick
            //handleSubmitButton={this.onClickConfirmReview}
            isWhiteCloseIcon={false}
            buttonStyle={{ justifyContent: "center" }}
          />

          <CustomModalV2
            open={selectTimeView}
            //open={true}
            handleClose={this.onClosePreferTime}
            loading={
              getScheduleCallBackLoading ||
              getDisabledTimeListsLoading ||
              createAppointmentLoading
            }
            modalTitle={"Preferred Time slot"}
            isTitleCenter
            titlestyle={classes.modalTitleStyle}
            modalDesign={classes.modalDesign}
            //submitButtonText={"Confirm"}
            modalComponent={this.promptChooseTimeV2()}
            disableBackdropClick
            //handleSubmitButton={this.onClickConfirmReview}
            isWhiteCloseIcon={false}
            buttonStyle={{ justifyContent: "center" }}
          />
          <CustomModalV2
            open={this.state.openCS}
            //loading={getScheduleCallBackLoading || getDisabledTimeListsLoading || createAppointmentLoading}
            //open={true}
            handleClose={this.onCloseHotline}
            modalTitle={"Call Customer Care Hotline"}
            isTitleCenter
            titlestyle={classes.modalTitleStyle}
            modalDesign={classes.modalDesign}
            //submitButtonText={"Confirm"}
            modalComponent={this.promptCustomerCareHotLine()}
            disableBackdropClick
            //handleSubmitButton={this.onClickConfirmReview}
            isWhiteCloseIcon={false}
            buttonStyle={{ justifyContent: "center" }}
          />

          <CustomModal
            //open={this.state.isVisibleCreditToeWallet}
            open={this.state.isVisibleAuthPrompt}
            submitButtonText={"Submit"}
            modalComponent={this.modalContainer()}
            handleSubmitButton={this.onClickUpdate}
            isVisibleCloseButton={true}
            handleClose={this.handleCloseCreditToeWallet}
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    profileListLoading: selector.getProfileLoading(state),
    profile: selector.getProfile(state),

    loginData: selector.getLoginData(state),
    loginLoading: selector.getLoginLoading(state),
    loginStatus: selector.getLoginStatus(state),

    getChatConfigurationLoading: selector.getChatConfigurationLoading(state),
    getChatConfigurationData: selector.getChatConfigurationData(state),
    getChatConfigurationStatus: selector.getChatConfigurationStatus(state),

    getCreateChatLoading: selector.getCreateChatLoading(state),
    getCreateChatData: selector.getCreateChatData(state),
    getCreateChatStatus: selector.getCreateChatStatus(state),

    getChatUpdateLoading: selector.getChatUpdateLoading(state),
    getChatUpdateData: selector.getChatUpdateData(state),
    getChatUpdateStatus: selector.getChatUpdateStatus(state),

    getChatMessageLoading: selector.getChatMessageLoading(state),
    getChatMessageData: selector.getChatMessageData(state),
    getChatMessageStatus: selector.getChatMessageStatus(state),

    getCreateMessageLoading: selector.getCreateMessageLoading(state),
    getCreateMessageData: selector.getCreateMessageData(state),
    getCreateMessageStatus: selector.getCreateMessageStatus(state),

    getTwilioQuitQueueLoading: selector.getTwilioQuitQueueLoading(state),
    getTwilioQuitQueueData: selector.getTwilioQuitQueueData(state),
    getTwilioQuitQueueStatus: selector.getTwilioQuitQueueStatus(state),

    getScheduleCallBackLoading: selector.getScheduleCallBackLoading(state),
    getScheduleCallBackData: selector.getScheduleCallBackData(state),
    getScheduleCallBackStatus: selector.getScheduleCallBackStatus(state),

    getDisabledTimeListsLoading: selector.getDisabledTimeListsLoading(state),
    getDisabledTimeListsData: selector.getDisabledTimeListsData(state),
    getDisabledTimeListsStatus: selector.getDisabledTimeListsStatus(state),

    createAppointmentLoading: selector.createAppointmentLoading(state),
    createAppointmentData: selector.createAppointmentData(state),
    createAppointmentStatus: selector.createAppointmentStatus(state),

    getChatReplyStatusLoading: selector.getChatReplyStatusLoading(state),
    getChatReplyStatusData: selector.getChatReplyStatusData(state),
    getChatReplyStatusStatus: selector.getChatReplyStatusStatus(state),

    connectLiveChatLoading: selector.connectLiveChatLoading(state),
    connectLiveChatData: selector.connectLiveChatData(state),
    connectLiveChatStatus: selector.connectLiveChatStatus(state),

    getInsiderClientInfoReqLoading: selector.getInsiderClientInfoReqLoading(
      state
    ),
    getInsiderClientInfoReqData: selector.getInsiderClientInfoReqData(state),
    getInsiderClientInfoReqStatus: selector.getInsiderClientInfoReqStatus(
      state
    ),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getProfile: () => dispatch(policyAction.getProfileListRequest()),
    getInsiderClientInfoReq: () =>
      dispatch(policyAction.getInsiderClientInfoReq()),
    postLoginRequest: (
      userID,
      password,
      authClientID,
      authRedirectUrl,
      authState,
      recaptchaToken
    ) =>
      dispatch(
        authAction.postLoginRequest(
          userID,
          password,
          authClientID,
          authRedirectUrl,
          authState,
          recaptchaToken
        )
      ),
    createAppointment: (
      threadID,
      bookSTime,
      bookETime,
      customerN,
      email,
      mobile
    ) =>
      dispatch(
        policyAction.createAppointment(
          threadID,
          bookSTime,
          bookETime,
          customerN,
          email,
          mobile
        )
      ),
    getDisabledTimeLists: (date) =>
      dispatch(policyAction.getDisabledTimeLists(date)),
    getScheduleCallBack: (threadID) =>
      dispatch(policyAction.getScheduleCallBack(threadID)),
    getTwilioQuitQueue: (threadID) =>
      dispatch(policyAction.getTwilioQuitQueue(threadID)),
    getChatConfiguration: () => dispatch(policyAction.getChatConfiguration()),
    getCreateChat: (sessionId) =>
      dispatch(policyAction.getCreateChat(sessionId)),
    getChatUpdate: (threadID, loginId) =>
      dispatch(policyAction.getChatUpdate(threadID, loginId)),
    getChatMessage: (threadID, loginId) =>
      dispatch(policyAction.getChatMessage(threadID, loginId)),
    getCreateMessage: (
      threadID,
      content,
      messageType,
      payload,
      attachedFiles,
      intent,
      level,
      loginId
    ) =>
      dispatch(
        policyAction.getCreateMessage(
          threadID,
          content,
          messageType,
          payload,
          attachedFiles,
          intent,
          level,
          loginId
        )
      ),
    getChatReplyStatus: (chatid, feedbackStatus) =>
      dispatch(policyAction.getChatReplyStatus(chatid, feedbackStatus)),
    connectLiveChat: (threadID) =>
      dispatch(policyAction.connectLiveChat(threadID)),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(withRouter(LiveChat)));
